import { get, post } from './http';

const medals = {
  // 用户勋章大厅列表
  getMedalList: (params) => {
    return get('/user/frontend/medal/center', params);
  },
  // 根据类型分页查询用户勋章
  getMedalTypeList: (params) => {
    return get('/user/frontend/medal/page', params);
  },
  // 查询勋章详情
  getMedalDetail: (params) => {
    return get('/user/frontend/medal/get', params);
  },
  // 领取勋章
  getMedal: (params) => {
    return post('/user/frontend/medal/receive', params);
  },
  // 佩戴勋章
  wearMedal: (params) => {
    return post('/user/frontend/medal/wear', params);
  },
  // 用户获取的勋章
  getReceivedMedal: (params) => {
    return get('/user/frontend/medal/receivedMedal', params);
  },
  // 勋章关联签到页 - 活动详情
  getActivityDetail: (params) => {
    return get('/campaign/frontend/meetup/info', params);
  },
  // 勋章关联签到页 - 签到
  toSignIn: (params) => {
    return post('/campaign/frontend/meetup/user/sign', params);
  }
};
export default medals;
